<script>
/** Eslint disabled for all variables not being camelcase */
/* eslint-disable camelcase */
import _ from 'lodash';
import { mapMutations, mapState } from 'vuex';
import WebmapVue from './WebMap';
import AreaVue from './Area';
import SearchBar from './SearchBar';
import DAModal from '../DAModal';
import InstrumentsVue from './Instruments';
import InfrastructuresVue from './Infrastructures';
import MapDetailsSidebarVue from './MapDetailsSidebar';

export default {
  props: ['site'],
  components: {
    'web-map': WebmapVue,
    'area-container': AreaVue,
    'instruments-container': InstrumentsVue,
    'search-bar': SearchBar,
    'da-modal': DAModal,
    'infrastructures-container': InfrastructuresVue,
    'map-details-sidebar': MapDetailsSidebarVue,
  },
  data() {
    return {
      sites: [],
      show: true,
      uniqueName: 'testcal',
      showSites: true,
      /** Configuration for tour */
      tourName: 'mapTour',
      tourCallbacks: {
        onStart: this.tourStart,
        onFinish: this.tourFinish,
        onSkip: this.tourSkip,
      },
      searchText: '',
      steps: [
        {
          target: '#v-step-0',
          content: 'Navigate through different applications by using the navbar, including the map, data visualization tools, and Jupyter notebooks.',
          params: {
            highlight: false,
          },
        },
        {
          target: '#v-step-1',
          content: 'Select an area of interest by clicking on a location.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-2',
          content: 'Choose which infrastructure is shown on the map by clicking to deselect one or more types. All infrastructure is shown by default.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-3',
          content: 'You can also filter the infrastructure by instrument. Click to select instruments of interest, and only infrastructure hosting those instruments will appear on the map.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-4',
          content: 'Explore the map interface for locations of cabled/uncabled instruments and seafloor photomosaics.',
          params: {
            highlight: false,
            placement: 'left',
          },
        },
      ],
    };
  },
  mounted() {
    /**
      * Use local storage to store a bool for the mapTour.
      * This allows for only one time execution at the very first visit
      */
    if (!localStorage.getItem(this.tourName)) {
      /** Access the desired tour */
      this.$tours[this.tourName].start();
      localStorage.setItem(this.tourName, true);
    }
    this.setdaModal(this.$refs['da-modal']);
    const that = this;
    /** Gets the site information */
    const site_list = _.uniqBy(this.instrument_list, 'site.properties.site_rd');
    this.sites = site_list.map((val) => {
      const { site } = val;
      const instruments = _.filter(that.instrument_list, [
        'site.properties.site_rd',
        site.properties.site_rd,
      ]);
      const uniqueInfra = _.uniqBy(
        instruments,
        'infrastructure.infrastructure_rd',
      );
      const infra_list = uniqueInfra.map((val2) => {
        const { infrastructure } = val2;
        const inst_list = _.filter(instruments, [
          'infrastructure.infrastructure_rd',
          infrastructure.infrastructure_rd,
        ]);
        return {
          ...infrastructure,
          instruments: inst_list.map((i) => i.instrument),
        };
      });
      const site_props = _.extend({}, site.properties, {
        infrastructures: infra_list,
      });
      return _.extend({}, site, { properties: site_props });
    });
  },
  computed: {
    ...mapState({
      researchSites: (state) => state.areas.features,
      sitePlatforms: (state) => state.sites,
      webmap: (state) => state.webmap,
      instruments: (state) => state.instruments,
    }),
    uniqueInstruments() {
      return _.uniqBy(this.instruments, 'asset_type');
    },
  },
  methods: {
    ...mapMutations(['setdaModal']),
    onSubmit(evt) {
      evt.preventDefault();
    },
    onReset(evt) {
      evt.preventDefault();
      /** Reset our form values */
      this.search = '';
      /** Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    /** GA event to know if a user started a page's tour */
    tourStart() {
      this.$ga('event', 'tutorial_begin', { tour: this.tourName });
    },
    /** GA even to know if a user completed a page's tour */
    tourFinish() {
      this.$ga('event', 'tutorial_complete', { tour: this.tourName });
    },
    /** GA event to know if a user skipped a page's tour */
    tourSkip() {
      this.$ga('event', 'tutorial_skip', { tour: this.tourName });
    },
    /** GA event to get the ID of a clicked element */
    getID(event) {
      this.$ga('event', event.target.id);
    },
  },
  watch: {
    showSites(newVal) {
      this.sitePlatforms.features.forEach((feature) => {
        const site_rd = feature.properties.reference_designator;
        const layerID = `platforms-${site_rd}`;
        if (this.webmap) {
          this.webmap.setLayoutProperty(layerID, 'visibility', newVal ? 'visible' : 'none');
        }
      });
    },
  },
};
</script>

<template>
  <b-row class="app-section">
    <b-col cols="12">
      <!-- Infrastructure detail map window -->
      <div>
        <map-details-sidebar></map-details-sidebar>
      </div>
    </b-col>
    <b-col cols="3" id="map-sidebar">
      <b-container class="p-0">
        <!-- Contains search box section of map sidebar -->
        <b-row>
          <b-col cols="12" style="padding: 8px;">
            <search-bar></search-bar>
          </b-col>
        </b-row>
        <!-- Contains everything in the research areas section of map sidebar -->
        <div id="v-step-1">
          <b-row>
            <b-col cols="12" style="padding: 8px;">
              <strong>
                <span class="sidebar-title">Research Areas</span>
              </strong>
              <i
                class="fas fa-info-circle"
                v-b-popover.hover.bottom="'Select an area of interest by clicking one below.'"
                title="Select Area"
              ></i>
              <b-row
                v-for="site in researchSites"
                :key="site.properties.area_name">
                <area-container
                  :site="site"
                ></area-container>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <!-- Contains everything in the instruments section of map sidebar -->
        <div id="v-step-3"><instruments-container></instruments-container></div>
        <!-- Contains everything in the infrastructures section of map sidebar -->
        <div id="v-step-2"><infrastructures-container></infrastructures-container></div>
      </b-container>
    </b-col>
    <b-col cols="9" class="map-app p-0" style="margin-right: 0px;">
      <web-map ref="webmap"></web-map>
    </b-col>
    <da-modal ref="da-modal"></da-modal>
    <!-- MOUNT TOUR | name can be used anywhere to start the tour -->
    <v-tour :name="tourName" :steps="steps"></v-tour>
  </b-row>
</template>

<style lang="css">
.sidebar-title {
  font-size: 1.3rem;
}
</style>
